/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElEmpty as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import { ElForm as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElCheckboxGroup as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/checkbox-group/style/css';
import { ElCheckbox as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElRadioGroup as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8a7201b0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "edit-plugin"
};
const _hoisted_2 = {
  class: "flex width100"
};
const _hoisted_3 = {
  class: "flex-1"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*必须上传png,jpg,gif格式的图片;", -1));
const _hoisted_5 = {
  key: 0,
  class: "tips"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 1,
  class: "noData"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import { apiUsdkSaveChannelPluginsNew } from '@/api/usdk';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'editPlugin',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dialogVisible = ref(false);
    const title = ref('');
    const pluginItems = ref();
    const allPlugins = ref();
    const oldAllPlugins = ref();
    const selectedIds = ref();
    const channel = ref();
    const gid = ref();
    const emits = __emit;
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const show = payload => {
      pluginItems.value = payload.data;
      selectedIds.value = payload.selectedIds;
      channel.value = payload.channel;
      gid.value = payload.gid;
      allPlugins.value = payload.allPlugins;
      oldAllPlugins.value = JSON.parse(JSON.stringify(payload.allPlugins));
      dialogVisible.value = true;
    };
    // 构建参数
    const createParams = () => {
      let opendPlugins = [];
      for (let key in allPlugins.value) {
        allPlugins.value[key].forEach(item => {
          if (selectedIds.value.includes(item.pid)) {
            opendPlugins.push(item);
          }
        });
      }
      let plusItemList = [];
      let isConf = [];
      opendPlugins.forEach(item => {
        isConf.push({
          name: item.name,
          conf: item.items.filter(item => item.value || item.valueFormat).length
        });
        item.items.forEach(c => {
          if ([2, 5].includes(Number(c.type))) {
            c.value = Array.isArray(c.valueFormat) ? c.valueFormat.join(',') : c.valueFormat;
          }
          if ([3, 4].includes(Number(c.type))) {
            let arr = c.valueFormat.map(item => {
              return item.url || item;
            });
            c.value = arr.join(',');
            console.log('c.value', c.value);
          }
          const obj = {
            id: c.hccpiid,
            cid: channel.value.cid,
            gid: gid.value,
            pid: c.pid,
            ptid: c.id,
            ptkey: c.key,
            value: c.value
          };
          plusItemList.push(obj);
        });
      });
      // 插件参数 必填一项
      let pName = isConf.filter(item => item.conf === 0).map(item => item.name).join(',');
      if (pName) {
        ElMessage({
          type: 'warning',
          message: `${pName}插件的参数不能为空!`
        });
        return;
      }
      let params = {
        plugs: selectedIds.value,
        plusItemList
      };
      return params;
    };
    const handleSubmit = () => {
      const {
        plugs,
        plusItemList
      } = createParams();
      const oldData = {};
      const dict = {};
      for (const key in oldAllPlugins.value) {
        oldAllPlugins.value[key].forEach(a => {
          a.items.forEach(b => {
            if ([2, 3, 4, 5].includes(Number(b.type))) {
              b.value = Array.isArray(b.valueFormat) ? b.valueFormat.join(',') : b.valueFormat;
            }
            oldData[b.key] = b.value;
          });
        });
      }
      const newData = {};
      for (const key in allPlugins.value) {
        allPlugins.value[key].forEach(a => {
          a.items.forEach(b => {
            if ([2, 3, 4, 5].includes(Number(b.type))) {
              b.value = Array.isArray(b.valueFormat) ? b.valueFormat.join(',') : b.valueFormat;
            }
            newData[b.key] = b.value;
            // debugger;
            dict[b.key] = {
              name: b.name
            };
          });
        });
      }
      const params = {
        gid: gid.value,
        cid: channel.value.cid,
        plugs: plugs.join(','),
        plusItemList: JSON.stringify(plusItemList)
      };
      apiUsdkSaveChannelPluginsNew(params).then(res => {
        if (res.code === 0) {
          handleClose();
          emits('success');
          customDataReport({
            eventName: 'plugin_config',
            dict,
            before: oldData,
            after: newData,
            operatePath: '出包-渠道配置-插件配置',
            gid: gid.value
          });
        }
      });
    };
    __expose({
      show,
      title
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_radio = __unplugin_components_1;
      const _component_el_radio_group = __unplugin_components_2;
      const _component_u_upload = _resolveComponent("u-upload");
      const _component_el_checkbox = __unplugin_components_3;
      const _component_el_checkbox_group = __unplugin_components_4;
      const _component_u_question = _resolveComponent("u-question");
      const _component_el_form_item = __unplugin_components_5;
      const _component_el_form = __unplugin_components_6;
      const _component_el_empty = __unplugin_components_7;
      const _component_el_button = __unplugin_components_8;
      const _component_el_dialog = __unplugin_components_9;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: _unref(title),
        width: "50%",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_unref(pluginItems).length > 0 ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "marginT20",
          "status-icon": ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pluginItems), c => {
            return _openBlock(), _createBlock(_component_el_form_item, {
              key: c.id,
              label: c.name
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [c.type == 1 ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: c.value,
                "onUpdate:modelValue": $event => c.value = $event,
                placeholder: `填写${c.name}`
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : c.type == 2 ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 1,
                modelValue: c.valueFormat,
                "onUpdate:modelValue": $event => c.valueFormat = $event
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.defValueFormat, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_radio, {
                    key: index,
                    label: item
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])) : c.type == 3 ? (_openBlock(), _createBlock(_component_u_upload, {
                key: 2,
                modelValue: c.valueFormat,
                "onUpdate:modelValue": $event => c.valueFormat = $event,
                limit: 1,
                "multi-part": ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])) : c.type == 4 ? (_openBlock(), _createBlock(_component_u_upload, {
                key: 3,
                modelValue: c.valueFormat,
                "onUpdate:modelValue": $event => c.valueFormat = $event,
                limit: 1,
                listType: "picture-card",
                "multi-part": "",
                accept: ".png,.jpg,.gif"
              }, {
                tip: _withCtx(() => [_hoisted_4]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])) : c.type == 5 ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                key: 4,
                modelValue: c.valueFormat,
                "onUpdate:modelValue": $event => c.valueFormat = $event
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.defValueFormat, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_checkbox, {
                    label: item,
                    key: index
                  }, null, 8, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true)]), c.tip ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_u_question, null, {
                default: _withCtx(() => [_createElementVNode("div", {
                  innerHTML: c.tip
                }, null, 8, _hoisted_6)]),
                _: 2
              }, 1024)])) : _createCommentVNode("", true)])]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        })) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_empty, {
          description: "未配置插件"
        })]))]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
});